import React from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import FilePatternForm from './FilePatternForm'
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/filePatternActions";
import History from "../../../History";
import {types} from './FilePatternForm';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const FilePatternCreate = props => {
    const { permissions, activeCustomer, translations, onCreateFilePattern, classes } = props;

    const handleSubmit = async data => {
        let objestToSend = {...data};
        if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
            objestToSend["Key"] = null;
        }
        objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
        let result = await onCreateFilePattern({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        Pattern: "",
        CustomerID: types && types.length > 0 ? types[0].value : '',
        Key: ''
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Pattern: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations['create_file_pattern'] || 'Create file pattern',
        ButtonSubmit: hasPermission(permissions, "system_file_pattern_create") || hasPermission(permissions, "file_pattern_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <FilePatternForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                permissions={permissions}
                CustomerIDPreviousState={''}
            />
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateFilePattern: filePattern => dispatch(actions.createFilePattern(filePattern)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(FilePatternCreate));